<template>
  <div>
      <button name="change-password"
              type="button"
              class="btn btn-blue"
              @click="changePasswordModal">Change Password
      </button>
    <label v-if="showResMessage">{{ resMessage }}</label>
      <change-password v-if="isVisible" @modal-closed="closeModal"></change-password>
  </div>
</template>

<script>
import ChangePassword from "./ChangePassword";
export default {
  name: "ChangePasswordBtn",
  components: {
    ChangePassword
  },
  data() {
    return {
      isVisible: false,
      resMessage: '',
      showResMessage: false
    }
  },
  methods: {
    changePasswordModal() {
      this.isVisible = !this.isVisible
    },
    closeModal(data) {
      this.isVisible = false
      this.resMessage = data
      this.showResMessage = true
    }
  }
}
</script>